<div class="container-fluid">
    <div class="card-header row d-flex align-items-center">
        <div class="col-sm-3">
            <app-search #searchPlaceholder [placeholder]="'Search'|translate"
                (keyup)="searchTable($event)"></app-search>
        </div>
        <div class="col-sm-9 d-flex justify-content-end align-items-center">
            <button class="btn submit" [routerLink]="['/app/attendance/field-mapping/add']"
                *ngIf="checkPermission('save')">
                {{'Add'|translate}}
            </button>
            <app-action-button (viewChange)="onViewChange($event)" [activeView]="viewType">
            </app-action-button>
            <app-table-export-import-button [tableId]="'menusTable'" class="import_btn" tablename="calendars"
                *ngIf="checkPermission('export')">
            </app-table-export-import-button>
        </div>
    </div>
    <div class="card-body mt-2">
        <!-- <p-table id="menusTable" styleClass="p-datatable-gridlines" [value]="listData"
            [tableStyle]="{ 'min-width': '60rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th class="tHead text-center" style="width: 5%">S.No</th>
                    <th class="tHead">
                        API Key
                    </th>
                    <th class="tHead">
                        Type
                    </th>
                    <th class="tHead">
                        Name
                    </th>
                    <th scope="" class="tHead">Created On</th>
                    <th scope="" class="tHead">Updated On</th>
                    <th scope="" class="tHead">Created By</th>
                    <th scope="" class="tHead">Updated By</th>
                    <th scope="" class="tHead text-center">Status</th>
                    <th style="text-align: center;" class="tHead" *ngIf="checkPermission('edit')">
                        Action
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-listData let-i="rowIndex">
                <tr>
                    <td class="text-center">{{ page == 0 ? i + 1 : i + 1 + pageSize * (page - 1) }}</td>
                    <td class="">{{ listData?.api_key }}</td>
                    <td class="">{{ listData?.type }}</td>
                    <td class="table-width-allowance">
                        {{ listData?.name }}
                    </td>
                    <td class="table-width-allowance">
                        {{ (listData?.created_at) ? (listData?.created_at | customDate:
                        (angularDateFormat || dateFormat) + ' hh:mm a') : '---' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ (listData?.updated_at && listData?.updated_by) ? (listData?.updated_at | customDate:
                        (angularDateFormat || dateFormat) + ' hh:mm a') : '---' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ listData?.createdBy?.name || '---' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ listData?.updatedBy?.name || '---' }}
                    </td>
                    <td class="text-center">
                        <button type="button"
                            class="btn btn-status {{ listData.status == '1' ? 'active' :  'inactive'}}">
                            {{listData.status ? 'Active' : 'Inactive'}}
                        </button>
                    </td>
                    <td style="text-align: center">
                        <i class="fa-regular fa-pen-to-square edit_icon" *ngIf="checkPermission('edit')"
                            (click)="navigateTo(listData._id)"></i>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <p class="text-center py-2" *ngIf="listData?.length == 0">No Records Found</p>
    </div>
    <div class="d-flex justify-content-center py-3">
        <ngb-pagination *ngIf="listData?.length != 0" class="pagination-master" [maxSize]="10"
            [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
            [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
        </ngb-pagination>
    </div> -->
        <div *ngIf="viewType === 'list'">
            <app-custom-table #customTable [listData]="listData" [selectedColumns]="myColumns" [menuId]="menuId"
                [tableName]="'fieldMapTable'" [moduleKey]="'fieldMapModule'" [totalRecords]="totalRecords"
                [maxSize]="pageSize" [collectionSize]="totalRecords" [page]="page" [pageSize]="pageSize"
                [sectionid]="42" (pageChanges)="handleFilterChange($event)" [angularDateFormat]="angularDateFormat"
                [dateFormat]="dateFormat"></app-custom-table>
            <ngb-pagination *ngIf="listData && listData.length != 0" class="pagination-master" [maxSize]="pageSize"
                [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
            </ngb-pagination>
        </div>
        <!-- GRID VIEW -->
        <div *ngIf="viewType === 'grid'">
            <app-custom-grid [listData]="listData" [totalRecords]="totalRecords" [canEdit]="checkPermission('edit')" [moduleKey]="'fieldMapModule'"
                [angularDateFormat]="angularDateFormat" [dateFormat]="dateFormat">
            </app-custom-grid>
            <ngb-pagination *ngIf="listData && listData.length != 0" class="pagination-master" [maxSize]="pageSize"
                [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
            </ngb-pagination>
        </div>
    </div>